module.exports = __webpack_public_path__ + "static/0021-7f1f224d99ad71cce4d28609682b0d21.png";